import type { UserRole } from "../../types/vtc";
import { useT } from "../../i18n";
import { cn } from "../../lib/format";

const ROLES: UserRole[] = ["driver", "company"];

interface RoleTabsProps {
  value: UserRole;
  onChange: (role: UserRole) => void;
}

/** Underlined tabs, as in the company area's vehicle editor. */
export default function RoleTabs({ value, onChange }: RoleTabsProps) {
  const t = useT();
  return (
    <div
      role="tablist"
      aria-label={t.auth.accountType}
      className="mb-6 flex gap-1 border-b border-line-strong"
    >
      {ROLES.map((role) => (
        <button
          key={role}
          type="button"
          role="tab"
          aria-selected={value === role}
          onClick={() => onChange(role)}
          className={cn(
            "-mb-px h-10 cursor-pointer border-0 border-b-2 bg-transparent px-3.5 text-sm font-medium transition-colors",
            value === role
              ? "border-ink text-ink"
              : "border-transparent text-muted hover:text-ink",
          )}
        >
          {t.auth.roles[role].tab}
        </button>
      ))}
    </div>
  );
}
